import { CALM_MS } from "./wind";

// A soft downwind "drift" from each station: where the air measured there is
// heading over the next half hour. Not a dispersion model, just an indication.
// Light wind: short, wide and denser. Strong wind: long, narrow and fainter.
const MINUTES = 30;
const LAYERS = 3;
const METERS_PER_DEG_LAT = 111320;
const CALM_RADIUS_M = 800;

const offset = (lat, lon, distanceM, bearingDeg) => {
  const bearing = (bearingDeg * Math.PI) / 180;
  const dLat = (distanceM * Math.cos(bearing)) / METERS_PER_DEG_LAT;
  const dLon =
    (distanceM * Math.sin(bearing)) /
    (METERS_PER_DEG_LAT * Math.cos((lat * Math.PI) / 180));
  return [lat + dLat, lon + dLon];
};

const halfAngle = (speed) => Math.min(35, Math.max(8, 35 - speed * 2.5));

// Polygons from the full drift down to the core; stacked with low opacity
// they fade out downwind.
export const driftAreas = (lat, lon, wind) => {
  if (wind.speed < CALM_MS) {
    return Array.from({ length: LAYERS }, (_, i) => {
      const radius = (CALM_RADIUS_M * (LAYERS - i)) / LAYERS;
      return Array.from({ length: 24 }, (_, step) =>
        offset(lat, lon, radius, step * 15),
      );
    });
  }

  const spread = halfAngle(wind.speed);
  const length = wind.speed * MINUTES * 60;
  return Array.from({ length: LAYERS }, (_, i) => {
    const reach = (length * (LAYERS - i)) / LAYERS;
    const arc = [];
    for (let a = -spread; a <= spread; a += spread / 6) {
      arc.push(offset(lat, lon, reach, wind.towards + a));
    }
    return [[lat, lon], ...arc];
  });
};

// Centre line along which the drift animation moves
export const driftLine = (lat, lon, wind) =>
  wind.speed < CALM_MS
    ? null
    : [
        [lat, lon],
        offset(lat, lon, wind.speed * MINUTES * 60 * 0.9, wind.towards),
      ];

// Per-layer fill opacity: denser in light wind, fainter in strong wind
export const driftOpacity = (speed) =>
  Math.min(0.08, Math.max(0.035, 0.3 / Math.max(speed, CALM_MS)));

// Bucket wind speed so the animation pace follows the wind
export const driftPace = (speed) => {
  if (speed < 4) return "slow";
  if (speed < 9) return "mid";
  return "fast";
};
